import React from 'react'
import { Button, Card, Col, Row } from 'react-bootstrap'
import arrowUp from '@assets/images/Dashboard/arrow-up.png'
import arrowDown from '@assets/images/Dashboard/arrow-down.png'
import {
  TrendDirection,
  BodyTitleData,
  DashboardUnits,
} from '@dataTypes/dashboard.types'

import './DashboardStyle.css'

type DashboardCardProps = {
  title: string
  iconPrimary?: string
  iconSecondary?: string
  trendDirection?: TrendDirection
  body: React.ReactElement
  onPrimaryIconClick?: () => void
  onSecondaryIconClick?: () => void
  classNameCard?: string
  classNameHeader?: string
  classNameBody?: string
  shouldHaveBodyTitle?: boolean
  bodyTitleData?: BodyTitleData
  isProgressBarChart?: boolean
  progressBarText?: {
    label: string
    isGoal: boolean
    icon?: string
    unit?: DashboardUnits
  }
  isBarChart?: boolean
  barChartText?: {
    label: string
    goal: number | string
    actual: number | string
    icon: string
  }
}

function DashboardCard({
  title,
  iconPrimary,
  iconSecondary,
  trendDirection,
  body,
  onPrimaryIconClick,
  onSecondaryIconClick,
  classNameCard,
  classNameHeader,
  classNameBody,
}: DashboardCardProps): React.ReactElement {
  return (
    <Card className={`${classNameCard || ''}`} id={title}>
      <Card.Header
        className={`bg-custom3 text-dark text-center p-3 pb-2 ${classNameHeader || ''}`}
      >
        {trendDirection && (
          <div className="text-center">
            <div className="card-arrow">
              <img
                src={`${trendDirection === 'up' ? arrowUp : arrowDown}`}
                height={'45'}
                alt="Arrow icon"
              ></img>
            </div>
          </div>
        )}
        <Row>
          <Col md={3}></Col>
          <Col md={6}>{title}</Col>
          <Col md={3} className="text-end">
            {iconPrimary && (
              <Button
                className={'trend-direction-btn me-2'}
                onClick={onPrimaryIconClick}
              >
                <i className={`${iconPrimary}`}></i>
              </Button>
            )}
            {iconSecondary && (
              <Button
                className={'trend-direction-btn'}
                onClick={onSecondaryIconClick}
              >
                <i className={`${iconSecondary}`}></i>
              </Button>
            )}
          </Col>
        </Row>
      </Card.Header>
      <Card.Body className={`${classNameBody || ''}`}>{body}</Card.Body>
    </Card>
  )
}

export default DashboardCard
